import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TrialBalanceTreeLine  {
    _originalTypeClassName = "zERP.BO.TrialBalanceTreeLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TrialBalanceTreeLine.translate = translateService;
}
this.children = [];
this.key = null;
this.leaf = false;
this.TrialBalanceTreeLineKey = null;
this._key = this.TrialBalanceTreeLineKey = 0; 
}

static translate: TranslateService;
_key: any;
key:any;
leaf:any;
data:any;
children:any;
private _TrialBalanceTreeLineKey:any;
get TrialBalanceTreeLineKey(): any {
    return this._TrialBalanceTreeLineKey;
  }
set TrialBalanceTreeLineKey(value: any) {
    this._TrialBalanceTreeLineKey = value;
    this._key = value;
  }
static setdata = ($this, value) => {
var oldValue = $this.data;
$this.data = value;
if (value != null) {
}
}
static setchildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.children == null) $this.children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.children.length > 0) {
                    Domain.TrialBalanceTreeLine.removechildren($this, $this.children[0]);
                }

                Domain.TrialBalanceTreeLine.addManychildren($this, copyItems);
            }
static addManychildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TrialBalanceTreeLine.addchildren($this, items[i]);
                }
            }
static addchildren = ($this, item) => {
                if ($this.children == null) $this.children = [];
                if (item == null || $this.children.indexOf(item) > -1) return;
                $this.children.push(item);
}
static addRangechildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TrialBalanceTreeLine.addchildren($this, item));
            }
static removechildren = ($this, item) => {
                if ($this == null || $this.children == null || $this.children.indexOf(item) === -1) return;
                var _index = $this.children.indexOf(item);
                $this.children.splice(_index, 1);
}
static clearchildren = ($this) => { $this.children = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TrialBalanceTreeLineKey == null || $this.TrialBalanceTreeLineKey == 0;
            }


}